import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";
import ListIcon from '@mui/icons-material/List';

import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {setLookViewType} from "../../../../actions/lookFunctions";
import {GroheGridIcon} from "../../../common/icons";
import COLOR_THEMES from "../../../../colorThemes";


const GroheMobileFooterViewButton = (props) => {

  const {intl, lookViewType, setLookViewType, activeTheme} = props;

  const viewButtonClick = () => {
    const newViewType = lookViewType === 1 ? 2 : 1;
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeaturesListViewType + newViewType);
    setLookViewType(newViewType);
  }

  return (
    <IconButton aria-label={intl.formatMessage({id:"iconButton.info"})}
                className={"gm-footer__menu look-icon look-button look-button--secondary look-button--no-radius"}
                onClick={viewButtonClick}>
      {lookViewType === 1 ? <ListIcon/> : (
        <SvgIcon>
          <GroheGridIcon color={COLOR_THEMES[activeTheme].primary}/>
        </SvgIcon>
      )}
    </IconButton>
  )
};

const mapStateToProps = (store) => {
  const {lookViewType} = store.lookState;
  const {activeTheme} = store.serverState;

  return {
    lookViewType,
    activeTheme,
  };
};

const mapDispatchToProps = {
  setLookViewType
};

export default (
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheMobileFooterViewButton)
  )
);
